/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import SPINNER from "../common_spinner/SPINNER";

/*REDUX*/
import { set_value_sini_data } from "../../App/actions/sini_data_actions";
import { post_ai_chat } from "../../App/actions/post_ai_chat";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const TEXT_AREA_CHAT = ({
  auth,
  loading_reducer,
  sini_data_reducer,
  sini,
  set_value_sini_data,
  post_ai_chat,
  on_scroll_down,
  post_activities,
}) => {
  const on_change_props = (event) => {
    const { max_rows_text_area } = sini_data_reducer;
    const textarea_line_height = 24;
    const previous_rows = event.target.rows;
    event.target.rows = 1;

    const current_rows = Math.floor(
      event.target.scrollHeight / textarea_line_height,
    );

    if (current_rows === previous_rows) {
      event.target.rows = current_rows;
    }

    if (current_rows >= max_rows_text_area) {
      event.target.rows = max_rows_text_area;
      event.target.scrollTop = event.target.scrollHeight;
    }

    const name = event.target.name;
    const value = event.target.value;

    set_value_sini_data({
      key: name,
      value,
    });

    if (value.trim() === "") {
      set_value_sini_data({
        key: "rows_text_area",
        value: 1,
      });
    } else {
      // Update rows based on actual content
      set_value_sini_data({
        key: "rows_text_area",
        value:
          current_rows < max_rows_text_area ? current_rows : max_rows_text_area,
      });
    }
  };

  const on_init_sini_data = () => {
    const { prompt_text } = sini_data_reducer;
    const { sini_v2_list, request_id_active, ai_parent_detail_list } = sini;

    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active,
    );
    const body = {
      request_id: request_id_active,
      user_message: prompt_text,
      sini_object,
    };
    post_ai_chat(body);

    set_value_sini_data({
      key: "prompt_text",
      value: "",
    });
    set_value_sini_data({
      key: "rows_text_area",
      value: 1,
    });
    on_scroll_down();

    post_activities({
      action: "site_analysis_ai",
    });
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props
  const { loading_item_array } = loading_reducer;
  const { prompt_text, rows_text_area } = sini_data_reducer;

  //content

  return (
    <main>
      <textarea
        placeholder={
          dict?.["Ask business, land prices, competitors"]?.[language]
        }
        rows={rows_text_area}
        className="margin_bottom"
        value={prompt_text}
        name="prompt_text"
        onChange={on_change_props}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            on_init_sini_data();
          }
        }}
        style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
        data-mapid="insertPromp"
      />

      <div>
        {loading_item_array.includes("gen_action") ? (
          <button
            className="button_big background_black margin_bottom"
            onClick={on_init_sini_data}
          >
            {dict?.["Sending"]?.[language]}{" "}
            <SPINNER
              unik="ai_spinner"
              width={10}
              border={0.25}
              color1="white"
              color2="#28a3f5"
            />
          </button>
        ) : (
          <button
            className="button_big background_black margin_bottom"
            onClick={on_init_sini_data}
            data-mapid="clickAsking"
          >
            {dict?.["Send"]?.[language]}
          </button>
        )}
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
  sini: state.sini,
});

export default connect(mapStateToProps, {
  set_value_sini_data,
  post_ai_chat,
  post_activities,
})(TEXT_AREA_CHAT);
